import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { ensureData } from '../../shared/utils/ensureData'

import { pickFromList, getConfig } from '../../shared/utils'

import FileList from '../../shared/components/FileList'

export default class Details extends Component {

  static propTypes = {
    current: PropTypes.object.isRequired,
    messageError: PropTypes.object,
    onSendMessage: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      question: ''
    }
  }

  @autobind
  handleChange({ target: { name, value } }) {
    this.setState({ [name]: value })
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()
    const {
      current: {
        id, name
      }
    } = this.props

    if (this.props.onSendMessage) {
      this.props.onSendMessage({
        target: {
          value: {
            recipientUserId: id,
            recipientType: 'museum',
            subject: name,
            message: this.state.question,
            type: 'question'
          }
        }
      })
    }

  }

  renderList(name) {
    const listName = `list_${name}`

    const { current } = this.props
    const entries = current[`${name}s`.replace(/ss$/, 's')]

    return (
      <ul className="info-list">
        {entries
          .map(({ value, attr }) => {
            const equipment = pickFromList(getConfig(listName), {
              key: 'id',
              value: value * 1
            })

            return (
              <li
                key={value}
              >
                <span className="info-list-label">
                  {equipment.title}
                </span>
                {attr !== undefined ? `: ${attr}` : null}
              </li>
            )

          })}
      </ul>
    )
  }

  render() {

    const {
      current: {
        name,
        description,
        address,
        phone,
        fax,
        email,
        images,
        links,
        website,
        openingHours,
        drivingInstructions,
        entryFeeAdults,
        entryFeePupils,
        entryFeeGroups,
        minGroupSize,
        equipments,
        qs,
      },
      messageError
    } = this.props

    return (
      <div className="vertical rating-layout">
        <div id="rating-container">
          <div>
            <h2>{name}</h2>
            <div className="row">
              <div
                className={`col-xs-${this.props.onSendMessage
                  ? 6
                  : 12}`}
              >

                <div className="data-group">
                  <em>{ensureData(description)}</em>
                  <br />
                  <br />
                </div>

                <div className="data-group">
                  <h3>1. Kontakt</h3>
                  <dl>
                    <dt>Adresse:</dt>
                    <dd>
                      {ensureData(address.street)}
                      {' '}
                      {ensureData(address.number)}
                      <br />
                      {ensureData(address.zip)}
                      {' '}
                      {ensureData(address.location)}
                      <br />
                      {pickFromList(getConfig('list_region'), {
                        key: 'id',
                        value: address.region * 1
                      }).title}
                    </dd>
                  </dl>

                  <dl>
                    <dt>Telefon:</dt>
                    <dd>{phone}</dd>

                    <dt>Fax:</dt>
                    <dd>{fax}</dd>

                    <dt>E-Mail:</dt>
                    <dd>
                      <a
                        href={`mailto:${email}`}
                      >
                        {email}
                      </a>
                    </dd>

                    <dt>Website:</dt>
                    <dd>
                      <a
                        href={website}
                      >
                        {website}
                      </a>
                    </dd>

                  </dl>
                </div>

                <div className="data-group">
                  <h3>3. Besuch</h3>
                  <dl>
                    <dt>Öffnungszeiten: </dt>
                    <dd>
                      <pre>
                        {ensureData(openingHours)}
                      </pre>
                    </dd>

                    <dt>Anfahrt:</dt>
                    <dd>{ensureData(drivingInstructions)}</dd>
                  </dl>

                  <strong>Eintritt</strong>
                  <dl>
                    <dt>Erwachsene:</dt>
                    <dd>
                      {ensureData(entryFeeAdults)}
                      {' '}
                      €
                    </dd>

                    <dt>Schüler:</dt>
                    <dd>
                      {ensureData(entryFeePupils)}
                      {' '}
                      €
                    </dd>

                    <dt>Schulklassen:</dt>
                    <dd>
                      {ensureData(entryFeeGroups)}
                      {' '}
                      € (
                      {ensureData(minGroupSize)}
                      {' '}
                      Begleitpersonen frei)
                    </dd>
                  </dl>
                </div>

                <div className="data-group">
                  <h3>4. Ausstattung und Qualitätssicherung</h3>
                  <div className="row">
                    <div className="col-xs-6">
                      <strong>Ausstattung:</strong>
                      <br />
                      {equipments.length
                        ? this.renderList('equipment')
                        : 'Keine Angabe'}
                    </div>

                    <div className="col-xs-6">
                      <strong>Qualitätssicherung:</strong>
                      <br />
                      {qs.length
                        ? this.renderList('qs')
                        : 'Keine Angabe'}
                    </div>
                  </div>
                </div>

                <div className="data-group">
                  <h3>5. Medien</h3>
                  <FileList list={links} type="file" />
                </div>

                <div className="data-group">
                  <FileList list={images} type="image" />
                </div>

              </div>

              {this.props.onSendMessage
                ? (
                  <div className="col-xs-6">
                    <div className="data-group">
                      <form
                        className="form form-horizontal"
                        onSubmit={this.handleSubmit}
                        onChange={this.handleChange}
                      >

                        <div className="form-group">

                          <label
                            className="col-xs-4"
                            htmlFor="rating-question"
                          >
                            Frage
                          </label>

                          <div className="col-xs-8">
                            <textarea
                              className="form-control"
                              id="rating-question"
                              name="question"
                              required
                              value={this.state.question}
                            />
                          </div>

                        </div>

                        {messageError
                          ? (
                            <div className="help-block error">
                              Fehler:
                              {' '}
                              {messageError}
                            </div>
                          )
                          : null}

                        <div className="form-group">

                          <div className="col-xs-8 col-xs-offset-4">
                            <button
                              className="action btn btn-primary"
                              type="submit"
                              disabled={!this.state.question.trim().length}
                            >
                              Frage stellen
                            </button>
                          </div>

                        </div>

                      </form>
                    </div>
                  </div>
                )
                : null}

            </div>
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/rating/components/Details.js